import { render, staticRenderFns } from "./CREAS.vue?vue&type=template&id=27ae2aee"
import script from "./CREAS.vue?vue&type=script&lang=js"
export * from "./CREAS.vue?vue&type=script&lang=js"
import style0 from "./CREAS.vue?vue&type=style&index=0&id=27ae2aee&prod&lang=css"
import style1 from "./CREAS.vue?vue&type=style&index=1&id=27ae2aee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports